<template>
  <div class="user dj-container bg-gray">
    <Row :gutter="16">
      <i-col span="4">
        <ul class="user-left bg-white">
          <li
            :class="{ active: activeName === 'info' }"
            @click="handleClick('info')"
          >
            <span>个人资料</span>
            <Icon type="ios-arrow-forward" />
          </li>
          <li
            :class="{ active: activeName === 'pwd' }"
            @click="handleClick('pwd')"
          >
            <span>修改密码</span>
            <Icon type="ios-arrow-forward" />
          </li>
        </ul>
      </i-col>
      <i-col span="20" v-show="activeName === 'info'">
        <Form
          class="user-right bg-white"
          ref="form"
          :model="form"
          :label-width="130"
          label-colon
          v-show="activeName === 'info'"
        >
          <FormItem prop="username" label="账号">
            <span>{{ form.username || "--" }}</span>
          </FormItem>
          <FormItem prop="orgName" label="账号角色">
            <span>{{ getRoleName(form.userType) || "--" }}</span>
          </FormItem>
          <FormItem prop="orgName" label="所属机构">
            <span>{{ form.orgName || "--" }}</span>
          </FormItem>
          <FormItem prop="inviteCode" label="我的邀请码">
            <span>{{ form.inviteCode || "--" }}</span>
          </FormItem>
          <FormItem prop="mobile" label="手机号">
            <i-input type="text" v-model="form.mobile" :readonly="loading" />
          </FormItem>
          <FormItem prop="nickName" label="昵称">
            <i-input type="text" v-model="form.nickName" :readonly="loading" />
          </FormItem>
          <FormItem prop="realName" label="真实姓名">
            <i-input type="text" v-model="form.realName" :readonly="loading" />
          </FormItem>
          <FormItem prop="email" label="电子邮箱">
            <i-input type="text" v-model="form.email" :readonly="loading" />
          </FormItem>
          <FormItem prop="qq" label="QQ">
            <i-input type="text" v-model="form.qq" :readonly="loading" />
          </FormItem>
          <FormItem prop="address" label="详细地址">
            <i-input type="text" v-model="form.address" :readonly="loading" />
          </FormItem>
          <FormItem prop="gender" label="性别">
            <!-- <i-input type="text" v-model="form.realName" :readonly="loading"/> -->
            <RadioGroup v-model="form.gender">
              <Radio label="MAN">男</Radio>
              <Radio label="WOMAN">女</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="updateMy" :loading="loading"
              >修改</Button
            >
          </FormItem>
        </Form>
      </i-col>
      <i-col span="20">
        <Form
          class="user-right bg-white"
          ref="passwordForm"
          :label-width="130"
          :model="passwordForm"
          :rules="formRules"
          v-show="activeName === 'pwd'"
        >
          <FormItem prop="password" label="当前密码">
            <i-input
              type="password"
              autocomplete="new-password"
              v-model="passwordForm.password"
              :readonly="loading"
              placeholder="当前密码"
            >
              <Icon type="ios-lock-outline" slot="prepend"></Icon>
            </i-input>
          </FormItem>
          <FormItem prop="newPassword" label="新密码">
            <i-input
              type="password"
              autocomplete="new-password"
              v-model="passwordForm.newPassword"
              :readonly="loading"
              placeholder="新密码"
            >
              <Icon type="ios-lock-outline" slot="prepend"></Icon>
            </i-input>
          </FormItem>
          <FormItem prop="newPassword2" label="新密码二次确认">
            <i-input
              type="password"
              autocomplete="new-password"
              v-model="passwordForm.newPassword2"
              :readonly="loading"
              placeholder="确认密码"
            >
              <Icon type="ios-lock-outline" slot="prepend"></Icon>
            </i-input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="changepwd" :loading="loading"
              >修改</Button
            >
          </FormItem>
        </Form>
      </i-col>
    </Row>
  </div>
</template>

<script>
export default {
  computed: {
    userInfo() {
      return this.$store.state.userInfo || {};
    },
  },
  created() {
    this.getMy();
  },
  data() {
    return {
      loading: false,
      activeName: "info",
      form: {},
      passwordForm: {
        password:"",
        newPassword:"",
        newPassword2:""
      },
      formRules: {
        password: {
          required: true,
          trigger: "blur",
          message: "请输入当前密码",
        },
        newPassword: {
          required: true,
          trigger: "blur",
          message: "请输入新密码",
        },
        newPassword2: [
          { required: true, trigger: "blur", message: "请再次输入新密码" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.passwordForm.newPassword) {
                callback(new Error("两次密码不一致"));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    handleClick(name) {
      this.activeName = name;
    },
    updateMy() {
      this.loading = true;
      this._r.put("sys/user/updateMy", this.form).then((res) => {
        // console.log('修改个人信息', res)
        if (res.code === 0) {
          this.$Message.success("个人信息修改成功！");
          this.getMy();
        } else {
          this.$Message.error(res.msg);
        }
        this.loading = false;
      });
    },
    getMy() {
      this._r.get("sys/user/my").then((res) => {
        if (res.code === 0) {
          // console.log(res, '个人信息')
          this.form = res.user;
          this.$store.commit("setUserInfo", res.user);
        }
      });
    },
    changepwd() {
      this.loading = true;
      const { newPassword, password } = this.passwordForm;
      this._r
        .put("sys/user/my/password", {
          newPassword,
          password,
        })
        .then((res) => {
          // console.log(res, '修改密码')
          if (res.code === 0) {
            this.$Message.success("密码修改成功！");
            this.passwordForm = {};
          } else {
            this.$Message.error(res.msg);
          }
          this.loading = false;
        });
    },
    getRoleName(userType) {
      // P_MANAGER(平台管理人员);O_MANAGER(机构管理人员);TEACHER(教师);STUDENT(学生);TOURIST(游客)
      switch (userType) {
        case "STUDENT":
          return "学生";
        case "TEACHER":
          return "教师";
        case "O_MANAGER":
          return "机构管理人员";
        case "P_MANAGER":
          return "平台管理人员";
        default:
          return "游客";
      }
    },
  },
};
</script>

<style lang="scss">
.user {
  .ivu-row {
    padding: 1rem;
  }
  .user-left {
    list-style: none;
    li {
      padding: 0.8rem 2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s;
      &.active {
        background-color: var(--active-color);
      }
    }
  }
  .user-right {
    padding: 1rem;
  }
  .form-panel {
    width: 20rem;
  }
}
</style>